import { h } from "hyperapp";
import listCSS from "../../../src/sections/unvisited-places/list.css";

export const secondaryTooltip = ({
  text = "",
  link = "",
  withIcon = false,
  texts = [],
}) => {
  if (withIcon)
    return (
      <div class={listCSS["main-tooltip3"]}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="15"
          viewBox="0 0 14 15"
          fill="none"
        >
          <path
            d="M13.7812 7.5C13.7812 11.246 10.7449 14.2812 7 14.2812C3.25508 14.2812 0.21875 11.246 0.21875 7.5C0.21875 3.75618 3.25508 0.71875 7 0.71875C10.7449 0.71875 13.7812 3.75618 13.7812 7.5ZM7.18197 2.96094C5.69182 2.96094 4.74141 3.58867 3.99509 4.70432C3.8984 4.84886 3.93075 5.04379 4.06932 5.14888L5.01813 5.86829C5.16045 5.97621 5.36323 5.95054 5.47381 5.81027C5.96228 5.19071 6.29721 4.83144 7.04069 4.83144C7.59929 4.83144 8.29024 5.19096 8.29024 5.73264C8.29024 6.14214 7.95219 6.35244 7.40064 6.66167C6.75741 7.02225 5.90625 7.47104 5.90625 8.59375V8.70312C5.90625 8.88433 6.05317 9.03125 6.23438 9.03125H7.76562C7.94683 9.03125 8.09375 8.88433 8.09375 8.70312V8.66668C8.09375 7.88842 10.3684 7.85602 10.3684 5.75C10.3684 4.16401 8.72323 2.96094 7.18197 2.96094ZM7 9.74219C6.30643 9.74219 5.74219 10.3064 5.74219 11C5.74219 11.6935 6.30643 12.2578 7 12.2578C7.69357 12.2578 8.25781 11.6935 8.25781 11C8.25781 10.3064 7.69357 9.74219 7 9.74219Z"
            fill="#2D6B94"
          />
        </svg>
        <div class={listCSS["tooltip-wrapper3"]}>
          <p class={listCSS["tooltip-text"]} style="line-height:20px">
            {texts[0]}{" "}
            <svg
              style="margin-top:-5px;margin-left:5px;"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M15.7812 13.8344L12.6656 10.7188C12.525 10.5781 12.3344 10.5 12.1344 10.5H11.625C12.4875 9.39688 13 8.00937 13 6.5C13 2.90937 10.0906 0 6.5 0C2.90937 0 0 2.90937 0 6.5C0 10.0906 2.90937 13 6.5 13C8.00937 13 9.39688 12.4875 10.5 11.625V12.1344C10.5 12.3344 10.5781 12.525 10.7188 12.6656L13.8344 15.7812C14.1281 16.075 14.6031 16.075 14.8938 15.7812L15.7781 14.8969C16.0719 14.6031 16.0719 14.1281 15.7812 13.8344ZM6.5 10.5C4.29063 10.5 2.5 8.7125 2.5 6.5C2.5 4.29063 4.2875 2.5 6.5 2.5C8.70938 2.5 10.5 4.2875 10.5 6.5C10.5 8.70938 8.7125 10.5 6.5 10.5Z"
                fill="white"
              />
            </svg>
            <br />
            {texts[1]} <br />
            {texts[2]} <b>{texts[3]}</b> {texts[4]}
            {link && (
              <a class={listCSS["tooltip-link"]} target="_blank" href={link}>
                Saiba mais.
              </a>
            )}
          </p>
        </div>
      </div>
    );
  return (
    <div class={listCSS["main-tooltip3"]}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
      >
        <path
          d="M13.7812 7.5C13.7812 11.246 10.7449 14.2812 7 14.2812C3.25508 14.2812 0.21875 11.246 0.21875 7.5C0.21875 3.75618 3.25508 0.71875 7 0.71875C10.7449 0.71875 13.7812 3.75618 13.7812 7.5ZM7.18197 2.96094C5.69182 2.96094 4.74141 3.58867 3.99509 4.70432C3.8984 4.84886 3.93075 5.04379 4.06932 5.14888L5.01813 5.86829C5.16045 5.97621 5.36323 5.95054 5.47381 5.81027C5.96228 5.19071 6.29721 4.83144 7.04069 4.83144C7.59929 4.83144 8.29024 5.19096 8.29024 5.73264C8.29024 6.14214 7.95219 6.35244 7.40064 6.66167C6.75741 7.02225 5.90625 7.47104 5.90625 8.59375V8.70312C5.90625 8.88433 6.05317 9.03125 6.23438 9.03125H7.76562C7.94683 9.03125 8.09375 8.88433 8.09375 8.70312V8.66668C8.09375 7.88842 10.3684 7.85602 10.3684 5.75C10.3684 4.16401 8.72323 2.96094 7.18197 2.96094ZM7 9.74219C6.30643 9.74219 5.74219 10.3064 5.74219 11C5.74219 11.6935 6.30643 12.2578 7 12.2578C7.69357 12.2578 8.25781 11.6935 8.25781 11C8.25781 10.3064 7.69357 9.74219 7 9.74219Z"
          fill="#2D6B94"
        />
      </svg>
      <div class={listCSS["tooltip-wrapper3"]}>
        <p class={listCSS["tooltip-text"]}>
          {text.replace(/<br\W*?\/>+/g, "\n")}{" "}
          {link && (
            <a class={listCSS["tooltip-link"]} target="_blank" href={link}>
              Saiba mais.
            </a>
          )}
        </p>
      </div>
    </div>
  );
};
